module.exports = __webpack_public_path__ + "static/media/8get.746ff901.svg";